import React from 'react';

const BottomFooterItems = () => [
  <a key="verzend" href="/verzend-en-retourbeleid.pdf">Verzend en retourbeleid</a>,
  <a key="voorwaarden" href="/algemene-voorwaarden-paul-de-vries-holding-bv.pdf">Algemene voorwaarden</a>,
];

export default BottomFooterItems;
